"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankIdError = exports.BankIdAuthType = exports.BankIdMethod = void 0;
var BankIdMethod;
(function (BankIdMethod) {
    BankIdMethod["BankID"] = "BANKID";
    BankIdMethod["MobileBankID"] = "MOBILE_BANKID";
    BankIdMethod["Default"] = "DEFAULT";
})(BankIdMethod || (exports.BankIdMethod = BankIdMethod = {}));
var BankIdAuthType;
(function (BankIdAuthType) {
    BankIdAuthType["QrCode"] = "QR_CODE";
    BankIdAuthType["SameDevice"] = "SAME_DEVICE";
})(BankIdAuthType || (exports.BankIdAuthType = BankIdAuthType = {}));
var BankIdError;
(function (BankIdError) {
    BankIdError["AlreadyInProgress"] = "ALREADY_IN_PROGRESS";
})(BankIdError || (exports.BankIdError = BankIdError = {}));
